import { render } from "./Phone.vue?vue&type=template&id=1557de48&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=1557de48&lang=scss&scoped=true"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/sign-log/advertising-register/step/Phone.vue'],['render',render],['__scopeId',"data-v-1557de48"],['__file',"Phone.vue"]])

export default __exports__